"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var waitlist_html_1 = __importDefault(require("./waitlist.html"));
var waitlist_controller_1 = __importDefault(require("./waitlist.controller"));
function getCourseTypes(CourseTypesModel) {
    return CourseTypesModel.get().then(function (response) {
        return response.courseTypes;
    });
}
getCourseTypes.$inject = ["CourseTypesModel"];
function getSessionTypes(DriveSessionTypesModel) {
    return DriveSessionTypesModel.get().then(function (response) {
        return response.sessionTypes;
    });
}
getSessionTypes.$inject = ["DriveSessionTypesModel"];
function config($stateProvider, $urlRouterProvider) {
    $stateProvider.state("drivecoach.admin.waitlist", {
        url: "/waitlist",
        controller: "AdminWaitlistController",
        controllerAs: "vm",
        template: waitlist_html_1.default,
        resolve: {
            courseTypes: getCourseTypes,
            sessionTypes: getSessionTypes,
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];
exports.default = angular_1.default
    .module("drivecoach.admin.waitlist", [])
    .config(config)
    .controller("AdminWaitlistController", waitlist_controller_1.default);
